export const SURVEY_THEME = {
    "themeName": "custom",
    "colorPalette": "light",
    "isPanelless": false,
    "backgroundOpacity": 1,
    "backgroundImageFit": "cover",
    "backgroundImageAttachment": "fixed",
    "cssVariables": {
        "--sjs-editorpanel-backcolor": "rgba(255, 255, 255, 1)",
        "--sjs-editorpanel-hovercolor": "rgba(255, 255, 255, 1)",
        "--sjs-questionpanel-cornerRadius": "8px",
        "--sjs-font-family": "Söhne, ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",
        "--sjs-font-pagetitle-family": "Söhne, ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",
        "--sjs-corner-radius": "6px",
        "--sjs-base-unit": "8px",
        "--sjs-shadow-small": "0px 0px 0px 1px rgba(210, 221, 236, 1)",
        "--sjs-font-questiontitle-color": "rgba(14, 33, 64, 0.91)",
        "--sjs-font-questiondescription-color": "rgba(75, 108, 146, 1)",
        "--sjs-shadow-inner": "inset 0px 0px 0px 1px rgba(210, 221, 236, 1)",
        "--sjs-font-editorfont-family": "Söhne, ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",
        "--sjs-font-editorfont-color": "#0E2140",
        "--sjs-font-editorfont-placeholdercolor": "rgba(14, 33, 64, 0.45)",
        "--sjs-border-default": "rgba(210, 221, 236, 1)",
        "--sjs-border-light": "rgba(210, 221, 236, 1)",
        "--sjs-general-backcolor": "rgba(255, 255, 255, 1)",
        "--sjs-general-backcolor-dark": "rgba(248, 248, 248, 1)",
        "--sjs-general-backcolor-dim-light": "rgba(249, 249, 249, 1)",
        "--sjs-general-backcolor-dim-dark": "rgba(243, 243, 243, 1)",
        "--sjs-general-forecolor": "rgba(0, 0, 0, 0.91)",
        "--sjs-general-forecolor-light": '#0E2140',
        "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
        "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",
        '--ctr-toolbox-item-icon-color': '#0E2140',
        '--ctr-toolbox-search-icon-color': '#0E2140',
        '--ctr-survey-question-panel-border-color-selected': "#8CA5F9",
        '--ctr-survey-question-panel-border-color-hovered': "#8CA5F9",
        '--ctr-survey-page-border-color-selected': "#8CA5F9",
        '--ctr-survey-page-border-color-hovered': "#8CA5F9",
        '--ctr-survey-page-background-color-selected': "#F2F5FF",
        '--ctr-survey-page-background-color-hovered': "#F2F5FF",
        "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
        "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
        "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
        "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
        "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(210, 221, 236, 1)",
        "--sjs-shadow-medium": "0px 2px 6px 0px rgba(0, 0, 0, 0.1)",
        "--sjs-shadow-large": "0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
        "--sjs-shadow-inner-reset": "inset 0px 0px 0px 0px rgba(210, 221, 236, 1)",
        "--sjs-border-inside": "rgba(0, 0, 0, 0.16)",
        "--sjs-special-red-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-green": "rgba(25, 179, 148, 1)",
        "--sjs-special-green-light": "rgba(25, 179, 148, 0.1)",
        "--sjs-special-green-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-blue": "rgba(67, 127, 217, 1)",
        "--sjs-special-blue-light": "rgba(67, 127, 217, 0.1)",
        "--sjs-special-blue-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
        "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
        "--sjs-special-yellow-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-article-font-xx-large-textDecoration": "none",
        "--sjs-article-font-xx-large-fontWeight": "500",
        "--sjs-article-font-xx-large-fontStyle": "normal",
        "--sjs-article-font-xx-large-fontStretch": "normal",
        "--sjs-article-font-xx-large-letterSpacing": "0",
        "--sjs-article-font-xx-large-lineHeight": "64px",
        "--sjs-article-font-xx-large-paragraphIndent": "0px",
        "--sjs-article-font-xx-large-textCase": "none",
        "--sjs-article-font-x-large-textDecoration": "none",
        "--sjs-article-font-x-large-fontWeight": "500",
        "--sjs-article-font-x-large-fontStyle": "normal",
        "--sjs-article-font-x-large-fontStretch": "normal",
        "--sjs-article-font-x-large-letterSpacing": "0",
        "--sjs-article-font-x-large-lineHeight": "56px",
        "--sjs-article-font-x-large-paragraphIndent": "0px",
        "--sjs-article-font-x-large-textCase": "none",
        "--sjs-article-font-large-textDecoration": "none",
        "--sjs-article-font-large-fontWeight": "500",
        "--sjs-article-font-large-fontStyle": "normal",
        "--sjs-article-font-large-fontStretch": "normal",
        "--sjs-article-font-large-letterSpacing": "0",
        "--sjs-article-font-large-lineHeight": "40px",
        "--sjs-article-font-large-paragraphIndent": "0px",
        "--sjs-article-font-large-textCase": "none",
        "--sjs-article-font-medium-textDecoration": "none",
        "--sjs-article-font-medium-fontWeight": "500",
        "--sjs-article-font-medium-fontStyle": "normal",
        "--sjs-article-font-medium-fontStretch": "normal",
        "--sjs-article-font-medium-letterSpacing": "0",
        "--sjs-article-font-medium-lineHeight": "32px",
        "--sjs-article-font-medium-paragraphIndent": "0px",
        "--sjs-article-font-medium-textCase": "none",
        "--sjs-article-font-default-textDecoration": "none",
        "--sjs-article-font-default-fontWeight": "400",
        "--sjs-article-font-default-fontStyle": "normal",
        "--sjs-article-font-default-fontStretch": "normal",
        "--sjs-article-font-default-letterSpacing": "0",
        "--sjs-article-font-default-lineHeight": "28px",
        "--sjs-article-font-default-paragraphIndent": "0px",
        "--sjs-article-font-default-textCase": "none",
        "--sjs-general-backcolor-dim": "#F9FBFD",
        "--sjs-primary-backcolor": "#4068EB",
        "--sjs-primary-backcolor-dark": "rgba(54, 88, 200, 1)",
        "--sjs-primary-backcolor-light": "rgba(64, 104, 235, 0.1)",
        "--sjs-primary-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",
        "--sjs-special-red": "rgba(206, 39, 39, 1)",
        "--sjs-special-red-light": "rgba(254, 235, 235, 0.1)",
        "--sjs-font-pagetitle-weight": "500",
        '--sjs-font-pagetitle-color': '#0E2140',
        '--sjs-font-pagedescription-color': '#0E2140'
    },
    "headerView": "basic"
} as const

export const SURVEY_THEME_DARK = {
    "themeName": "custom",
    "colorPalette": "light",
    "isPanelless": false,
    "backgroundOpacity": 1,
    "backgroundImageFit": "cover",
    "backgroundImageAttachment": "fixed",
    "cssVariables": {
        "--sjs-editorpanel-backcolor": "rgba(255, 255, 255, 1)",
        "--sjs-editorpanel-hovercolor": "rgba(255, 255, 255, 1)",
        "--sjs-questionpanel-cornerRadius": "8px",
        "--sjs-font-family": "Söhne, ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",
        "--sjs-font-pagetitle-family": "Söhne, ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",
        "--sjs-corner-radius": "6px",
        "--sjs-base-unit": "8px",
        "--sjs-shadow-small": "0px 0px 0px 1px rgba(210, 221, 236, 1)",
        "--sjs-font-questiontitle-color": "rgba(14, 33, 64, 0.91)",
        "--sjs-font-questiondescription-color": "rgba(75, 108, 146, 1)",
        "--sjs-shadow-inner": "inset 0px 0px 0px 1px rgba(210, 221, 236, 1)",
        "--sjs-font-editorfont-family": "Söhne, ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",
        "--sjs-font-editorfont-color": "#0E2140",
        "--sjs-font-editorfont-placeholdercolor": "rgba(14, 33, 64, 0.45)",
        "--sjs-border-default": "rgba(210, 221, 236, 1)",
        "--sjs-border-light": "rgba(210, 221, 236, 1)",
        "--sjs-general-backcolor": "rgba(255, 255, 255, 1)",
        "--sjs-general-backcolor-dark": "rgba(248, 248, 248, 1)",
        "--sjs-general-backcolor-dim-light": "rgba(249, 249, 249, 1)",
        "--sjs-general-backcolor-dim-dark": "rgba(243, 243, 243, 1)",
        "--sjs-general-forecolor": "rgba(0, 0, 0, 0.91)",
        "--sjs-general-forecolor-light": '#0E2140',
        "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
        "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",
        '--ctr-toolbox-item-icon-color': '#0E2140',
        '--ctr-toolbox-search-icon-color': '#0E2140',
        '--ctr-survey-question-panel-border-color-selected': "#8CA5F9",
        '--ctr-survey-question-panel-border-color-hovered': "#8CA5F9",
        '--ctr-survey-page-border-color-selected': "#8CA5F9",
        '--ctr-survey-page-border-color-hovered': "#8CA5F9",
        '--ctr-survey-page-background-color-selected': "#F2F5FF",
        '--ctr-survey-page-background-color-hovered': "#F2F5FF",
        "--sjs-secondary-backcolor": "rgba(255, 152, 20, 1)",
        "--sjs-secondary-backcolor-light": "rgba(255, 152, 20, 0.1)",
        "--sjs-secondary-backcolor-semi-light": "rgba(255, 152, 20, 0.25)",
        "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
        "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(210, 221, 236, 1)",
        "--sjs-shadow-medium": "0px 2px 6px 0px rgba(0, 0, 0, 0.1)",
        "--sjs-shadow-large": "0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
        "--sjs-shadow-inner-reset": "inset 0px 0px 0px 0px rgba(210, 221, 236, 1)",
        "--sjs-border-inside": "rgba(0, 0, 0, 0.16)",
        "--sjs-special-red-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-green": "rgba(25, 179, 148, 1)",
        "--sjs-special-green-light": "rgba(25, 179, 148, 0.1)",
        "--sjs-special-green-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-blue": "rgba(67, 127, 217, 1)",
        "--sjs-special-blue-light": "rgba(67, 127, 217, 0.1)",
        "--sjs-special-blue-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
        "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
        "--sjs-special-yellow-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-article-font-xx-large-textDecoration": "none",
        "--sjs-article-font-xx-large-fontWeight": "500",
        "--sjs-article-font-xx-large-fontStyle": "normal",
        "--sjs-article-font-xx-large-fontStretch": "normal",
        "--sjs-article-font-xx-large-letterSpacing": "0",
        "--sjs-article-font-xx-large-lineHeight": "64px",
        "--sjs-article-font-xx-large-paragraphIndent": "0px",
        "--sjs-article-font-xx-large-textCase": "none",
        "--sjs-article-font-x-large-textDecoration": "none",
        "--sjs-article-font-x-large-fontWeight": "500",
        "--sjs-article-font-x-large-fontStyle": "normal",
        "--sjs-article-font-x-large-fontStretch": "normal",
        "--sjs-article-font-x-large-letterSpacing": "0",
        "--sjs-article-font-x-large-lineHeight": "56px",
        "--sjs-article-font-x-large-paragraphIndent": "0px",
        "--sjs-article-font-x-large-textCase": "none",
        "--sjs-article-font-large-textDecoration": "none",
        "--sjs-article-font-large-fontWeight": "500",
        "--sjs-article-font-large-fontStyle": "normal",
        "--sjs-article-font-large-fontStretch": "normal",
        "--sjs-article-font-large-letterSpacing": "0",
        "--sjs-article-font-large-lineHeight": "40px",
        "--sjs-article-font-large-paragraphIndent": "0px",
        "--sjs-article-font-large-textCase": "none",
        "--sjs-article-font-medium-textDecoration": "none",
        "--sjs-article-font-medium-fontWeight": "500",
        "--sjs-article-font-medium-fontStyle": "normal",
        "--sjs-article-font-medium-fontStretch": "normal",
        "--sjs-article-font-medium-letterSpacing": "0",
        "--sjs-article-font-medium-lineHeight": "32px",
        "--sjs-article-font-medium-paragraphIndent": "0px",
        "--sjs-article-font-medium-textCase": "none",
        "--sjs-article-font-default-textDecoration": "none",
        "--sjs-article-font-default-fontWeight": "400",
        "--sjs-article-font-default-fontStyle": "normal",
        "--sjs-article-font-default-fontStretch": "normal",
        "--sjs-article-font-default-letterSpacing": "0",
        "--sjs-article-font-default-lineHeight": "28px",
        "--sjs-article-font-default-paragraphIndent": "0px",
        "--sjs-article-font-default-textCase": "none",
        "--sjs-general-backcolor-dim": "#F9FBFD",
        "--sjs-primary-backcolor": "#4068EB",
        "--sjs-primary-backcolor-dark": "rgba(54, 88, 200, 1)",
        "--sjs-primary-backcolor-light": "rgba(64, 104, 235, 0.1)",
        "--sjs-primary-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",
        "--sjs-special-red": "rgba(206, 39, 39, 1)",
        "--sjs-special-red-light": "rgba(254, 235, 235, 0.1)",
        "--sjs-font-pagetitle-weight": "500",
        '--sjs-font-pagetitle-color': 'white',
        '--sjs-font-pagedescription-color': 'white'
    },
    "headerView": "basic"
} as const

export const THEME_TO_BACKGROUND: Record<'plain' | 'light' | 'dark', string | undefined> = {
    plain: undefined,
    light: '/survey-light-background.svg',
    dark: '/survey-dark-background.svg'
} as const

export enum FormActionTypes {
    dataInput,
    reviewDocument
}
